import type { FormControl } from '@angular/forms';

export enum FreightlancerTaskListSteps {
  START = 1,
  PICKUP = 2,
  DELIVERY = 3,
  PAYMENT = 4,
}

export const FREIGHTLANCER_TASKLIST_STEP_NAME: {
  [key: string]: FreightlancerTaskListSteps;
} = {
  contacts: FreightlancerTaskListSteps.START,
  pickup: FreightlancerTaskListSteps.PICKUP,
  delivery: FreightlancerTaskListSteps.DELIVERY,
  milestone: FreightlancerTaskListSteps.PAYMENT,
};

export const GPS_LINK_SEPARATOR = '??gpsLinkSeparator??';

export const FREIGHTLANCER_TASKLIST_SECTION_TITLE_MAPPING: {
  readonly [k in FreightlancerTaskListSteps]?: string;
} = {
  [FreightlancerTaskListSteps.START]: 'View details and POD',
  [FreightlancerTaskListSteps.PICKUP]: 'Pickup',
  [FreightlancerTaskListSteps.DELIVERY]: 'Delivery',
  [FreightlancerTaskListSteps.PAYMENT]: 'Milestones',
};

export enum FreightlancerTasklistDetailsType {
  PICKUP = 1,
  DROPOFF = 2,
}

export interface FreightlancerTaskListFormGroupType {
  startTime: FormControl<Date>;
  pickupNotes: FormControl<string>;
  gpsTrackingLink: FormControl<string>;
  pickupTime: FormControl<Date>;
  deliveryNotes: FormControl<string>;
  deliveryTime: FormControl<Date>;
}
